import api from "./config";

export default {
  terminals: async () => {
    const response = await api.get("/api/terminals");
    return response.data;
  },
};
